import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PagePreloaderDirective } from './page-preloader.directive';
import { PreloaderComponent } from './preloader.component';

@NgModule({
  declarations: [PreloaderComponent, PagePreloaderDirective],
  exports: [PreloaderComponent, PagePreloaderDirective],
  imports: [CommonModule]
})
export class PreloaderModule {}

export * from './page-preloader.directive';
export * from './preloader-component.abstract';
export * from './preloader.component';
